import { NavLink } from "react-router-dom";
import { CDP_PATHS } from "../constants";

const TABS = [
  { to: CDP_PATHS.REGISTRATIONS, label: "Registrations" },
  { to: CDP_PATHS.DEMOGRAPHICS, label: "Demographics" },
];

export default function CdpSubNav() {
  return (
    <div className="mb-6 flex justify-center">
      <nav className="flex divide-x divide-gray-200 overflow-hidden rounded-lg shadow">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              `group relative min-w-0 flex-1 overflow-hidden px-8 py-4 text-center text-sm font-bold uppercase focus:z-10 ${
                isActive
                  ? "bg-red-500 text-gray-50 hover:bg-red-600"
                  : "bg-gray-50 text-gray-500 hover:bg-gray-100"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span>{tab.label}</span>
                <span
                  aria-hidden="true"
                  className={`absolute inset-x-0 bottom-0 h-0.5 ${isActive ? "bg-red-500" : ""}`}
                />
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
